import styled from "styled-components";

export const Label = styled.label`
  font-size: 1.6rem;
  font-weight: 500;
`;
